import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";

export function CTASection({
  headline = "Talk to a senior HR expert today.",
  sub = "No hard sell, no obligation. Just an honest conversation about your business.",
  primaryHref = "/contact-hr-experts",
  primaryLabel = "Get a free consultation",
}: {
  headline?: string;
  sub?: string;
  primaryHref?: "/contact-hr-experts" | "/services" | "/hr-packages";
  primaryLabel?: string;
}) {
  return (
    <section className="px-6 py-20 lg:px-8 lg:py-24">
      <div className="mx-auto max-w-5xl overflow-hidden rounded-3xl bg-brand px-8 py-16 text-brand-foreground sm:px-16">
        <div className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
          <div className="max-w-xl">
            <h2 className="font-serif text-3xl leading-tight tracking-tight sm:text-4xl">{headline}</h2>
            <p className="mt-4 text-base text-brand-foreground/70">{sub}</p>
          </div>
          <Link
            to={primaryHref}
            className="inline-flex items-center gap-2 rounded-md bg-accent px-5 py-3 text-sm font-medium text-accent-foreground transition hover:brightness-110"
          >
            {primaryLabel}
            <ArrowRight className="size-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
